import * as React from 'react';
import type { SVGProps } from 'react';
const SvgViolationTickets = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M11 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14M8.03 5.97a.75.75 0 0 0-1.06 1.06l7.016 7.016a.75.75 0 1 0 1.06-1.06z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M7.55.55c1.324 0 2.562.367 3.618 1.006a8.3 8.3 0 0 0-7.993 11.458A7 7 0 0 1 7.55.55"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgViolationTickets;
